import { useLanguage } from "@/lib/i18n";
import { StoreBadges } from "@/components/common/StoreBadges";

export function Download() {
  const { t } = useLanguage();

  // Parse the title with placeholder for highlighted text
  const titleParts = t("download.readyToMakeReceipts").split(/{[^}]*}/);
  const highlightedText = t("features.usefulAgain");

  return (
    <section id="download" className="relative overflow-hidden">
      {/* Gradient top border */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

      <div className="relative bg-secondary noise-bg py-24 sm:py-36 lg:py-44">
        {/* Central radial glow */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 60% 50% at 50% 50%, hsl(var(--primary) / 0.12) 0%, transparent 70%)",
          }}
        />

        {/* Decorative floating blurred circle -- primary */}
        <div
          className="pointer-events-none absolute -top-20 -left-20 h-72 w-72 animate-float rounded-full bg-primary/[0.07] blur-3xl sm:h-96 sm:w-96"
          aria-hidden="true"
        />

        {/* Decorative floating blurred circle -- accent */}
        <div
          className="pointer-events-none absolute -bottom-24 -right-24 h-64 w-64 animate-float rounded-full bg-accent/[0.06] blur-3xl sm:h-80 sm:w-80"
          style={{ animationDelay: "2s" }}
          aria-hidden="true"
        />

        {/* Content */}
        <div className="relative z-10 mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="font-heading text-4xl leading-tight tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            {titleParts[0]}
            <span className="text-gradient">{highlightedText}</span>
            {titleParts[1] || ""}
          </h2>

          <p className="mx-auto mt-6 max-w-xl text-lg text-muted-foreground sm:text-xl">
            {t("download.downloadReFoundToday")}
          </p>

          <div className="mt-12">
            <StoreBadges location="download_section" size="lg" />
          </div>

          <p className="mt-6 text-sm font-medium tracking-wide text-muted-foreground/70">
            {t("download.freeToDownload")}
          </p>
        </div>
      </div>
    </section>
  );
}
